import { gql } from "@apollo/client";
import { graphql } from "@apollo/client/react/hoc";
import InterviewRequestFragment from "common/fragments/InterviewRequest";

const Mutation = gql`
  mutation updateCalendar(
    $time_zone_name: String
    $availability_buffer: String
    $appointment_slots: [AppointmentSlotInput]
  ) {
    updateCalendar(
      time_zone_name: $time_zone_name
      availability_buffer: $availability_buffer
      appointment_slots_attributes: $appointment_slots
    ) {
      time_zone_name
      availability_buffer
      availability_buffer_time
      google_synced
      appointment_slots {
        id
        start_time
        end_time
      }
      interview_requests {
        ...InterviewRequestFields
      }
    }
  }
  ${InterviewRequestFragment}
`;

export default graphql(Mutation);
